import React, { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import * as Action from "../../../store/redux/student_reducer.js";
import "./courseRegistration.css";
let courses, studentData;

const CourseRegistration = ({ info, setLoading }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [selectedCourses, setSelectedCourses] = useState([]);
  const studentId =
    info?.admission_number || info?.academicInfo?.admission_number;
  const params = {
    pressent_level: info?.academicInfo?.state?.level,
    pressent_semester: info?.academicInfo?.state?.pressent_semester,
  };

  const dispatchStateUpdates = async () => {
    setLoading(true);
    await axios
      .post(
        `${
          process.env.REACT_APP_SERVER_SCRIPT_HOST
        }/student_state_change/${encodeURIComponent(studentId)}`,
      )
      .then((response) => {
        studentData = response.data;
        console.log(studentData);
        dispatch(DispatchStudentData());
        if (response?.data.status === 201) {
          enqueueSnackbar(`Success!`, {
            variant: "success",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        } else if (response?.data.status === 401) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "error",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const DispatchStudentData = () => async (dispatch) => {
    try {
      // dispatch an action
      dispatch(Action.startStudentAction({ studentData }));
    } catch (error) {
      console.log(error);
    }
  };

  async function getMWCourses() {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/course_registration/getMidWiferyCourses`,
        { params },
      );
      if (response?.data.status === 201) {
        courses = response?.data.data;
        console.log(courses);
        enqueueSnackbar(`${response?.data.message}`, {
          variant: "success",
          autoHideDuration: 3000,
          ContentProps: {
            style: { fontSize: "16px", fontWeight: "bold" },
          },
        });
      }
      console.log(response);
    } catch (error) {
      console.error("Error fetching courses:", error);
      enqueueSnackbar(`Something went wrong, please try again later`, {
        variant: "error",
        autoHideDuration: 3000,
        ContentProps: {
          style: { fontSize: "16px", fontWeight: "bold" },
        },
      });
    } finally {
      setLoading(false);
    }
  }
  async function getGNCourses() {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/course_registration/getNursingCourses`,
        { params },
      );
      if (response?.data.status === 201) {
        courses = response?.data.data;
        console.log(courses);
        enqueueSnackbar(`${response?.data.message}`, {
          variant: "success",
          autoHideDuration: 3000,
          ContentProps: {
            style: { fontSize: "16px", fontWeight: "bold" },
          },
        });
      }
      console.log(response);
    } catch (error) {
      console.error("Error fetching courses:", error);
      enqueueSnackbar(`Something went wrong, please try again later`, {
        variant: "error",
        autoHideDuration: 3000,
        ContentProps: {
          style: { fontSize: "16px", fontWeight: "bold" },
        },
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (info?.academicInfo?.programme === "Midwifery") {
      getMWCourses();
    } else if (info?.academicInfo?.programme === "General Nursing") {
      getGNCourses();
    }
  }, [info?.academicInfo?.programme]); // ✅ Add dependency

  const handleCheckboxChange = (courseCode) => {
    setSelectedCourses((prevSelected) =>
      prevSelected.includes(courseCode)
        ? prevSelected.filter((code) => code !== courseCode)
        : [...prevSelected, courseCode],
    );
  };

  const handleSubmit = async () => {
    const currentSession = info?.academicInfo?.state?.pressent_session;
    // Ensure courses are available before mapping
    if (!courses || courses.length === 0) {
      alert("No courses available to register.");
      return;
    }

    // Format selected courses
    const formattedCourses = selectedCourses
      .map((courseCode) => {
        const course = courses.find((c) => c.courseCode === courseCode);
        if (!course) return null; // Safety check in case of missing course data

        return {
          student_adm:
            info?.admission_number || info?.academicInfo?.admission_number,
          status: "Enrolled",
          courseCode: course.courseCode,
          courseTitle: course.courseTitle,
          creditUnit: course.creditUnit,
          grade: "",
          semester: course.semester,
          session: currentSession,
          status: "Enrolled",
          numberofHours: { lectures: 0, practical: 0, tutorial: 0, total: 0 },
          course_reg_date: new Date().toISOString(),
          continue_assessment: [],
        };
      })
      .filter(Boolean); // Remove null values

    if (formattedCourses.length === 0) {
      alert("No valid courses selected.");
      return;
    }

    // Construct the payload
    const payload = {
      student_id:
        info?.admission_number || info?.academicInfo?.admission_number,
      registeredCourses: formattedCourses,
    };
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/post_course_registration`,
        payload,
      );

      enqueueSnackbar(`${response.data.message}`, {
        variant: "success",
        autoHideDuration: 3000,
        ContentProps: {
          style: { fontSize: "16px", fontWeight: "bold" },
        },
      });
      setSelectedCourses([]);
      dispatchStateUpdates();
      setLoading(false);
    } catch (error) {
      console.error(
        "❌ Error registering courses:",
        error.response?.data || error,
      );
      enqueueSnackbar(
        `Registration failed: ${
          error.response?.data?.message || "Unknown error"
        }`,
        {
          variant: "success",
          autoHideDuration: 3000,
          ContentProps: {
            style: { fontSize: "16px", fontWeight: "bold" },
          },
        },
      );
      setLoading(false);
    }
  };

  return (
    <div className="course-registration">
      <table className="fx-cl spacem">
        <thead className="fx-cl spacem">
          <tr>
            <th>S/N</th>
            <th>Course Code</th>
            <th>Course Title</th>
            <th>Course Unit</th>
            <th>Course Semester</th>
          </tr>
        </thead>
        <tbody className="fx-cl">
          {courses?.map((response, index) => {
            return (
              <tr key={index}>
                <td>
                  <span>{index + 1}</span>
                </td>
                <td className=" fx-ac space2">
                  <input
                    type="checkbox"
                    value={response.courseCode}
                    checked={selectedCourses.includes(response.courseCode)}
                    onChange={() => handleCheckboxChange(response.courseCode)}
                  />
                  <span>{response.courseCode}</span>
                </td>
                <td>{response.courseTitle}</td>
                <td>{response.creditUnit}</td>
                <td>{response.semester}</td>
              </tr>
            );
          })}
        </tbody>
        <div className="fx-jb">
          <span>&nbsp;</span>

          <button type="submit" onClick={() => handleSubmit()}>
            Register Courses
          </button>
        </div>
      </table>
    </div>
  );
};

export default CourseRegistration;
